class GongYeSuPaiEvent {
  constructor() {
    this.list = {}
    this.key = {
      SET_CURRENT_MENU: 'SET_CURRENT_MENU',
    }
  }
  listen(key, fn) {
    this.list[key] = fn
  }
  trigger(key) {
    if (this.list[key]) {
      this.list[key].apply(this, Array.prototype.slice.call(arguments).slice(1))
    }
  }
}

export default new GongYeSuPaiEvent()